import { connect } from "react-redux";
import { nsLoginSelect } from "../../redux/selector/nsLoginSelector";
import { startNSLogin } from "../../redux/slice/nsLoginSlice";
import { LoginButton } from "../../components/RegularComponents";
import {
  APPLICATION_MODE_NEW,
  APPLICATION_TYPE_MORTGAGE_LENDER_LICENCE,
  SEGUE_NAME,
} from "../../app/constants";
import { saveSegueDetails } from "../../redux/slice/primaryAgencyApplicationSlice"
import { isMaintenanceModeOn } from "../../app/SystemMaintenanceModeUtils";
import { SystemMaintenanceMessage } from "../../components/SystemMaintenanceMessage";

function ApplyForMortgageLenderLicenceView(props) {
  const { dispatch } = props;
  let { nsLogin } = props;
  const { loginStatus } = nsLogin;

  if (nsLogin[APPLICATION_TYPE_MORTGAGE_LENDER_LICENCE]) {
    nsLogin = nsLogin[APPLICATION_TYPE_MORTGAGE_LENDER_LICENCE];
    // debugger;
  }

  const onLoginClick = () => {
    dispatch(
      saveSegueDetails({
        name: SEGUE_NAME.LOGIN,
        applicationType: APPLICATION_TYPE_MORTGAGE_LENDER_LICENCE,
        applicationMode: APPLICATION_MODE_NEW,
      })
    );

    dispatch(startNSLogin());

    // hard push for now
    //dispatch(push(`${ROUTE_PATH.ML_APP}${ROUTE_PATH.ML_NEXT_STEPS}`))
  };

  return (
    <>
      <div className={"container"}>
        <div className="row">
          <div className="col-lg-9">
            <h1>
              Sign in to start your application for a Mortgage Lender licence.
            </h1>
            <p>
              Create an account or sign in with an existing account to apply for a mortgage lender licence.
            </p>
          </div>
        </div>
        <div className="row">
          <div className="col-lg-8">
            <LoginButton
              disabled={isMaintenanceModeOn()}
              style={{ marginTop: "20px" }}
              onClick={onLoginClick}
              header={"Login / Create Account"}
              subHeader={
                "A secure way to access Government of Nova Scotia online services"
              }
            />

            {loginStatus === "in-progress" ? (
              <div className="fa-2x">
                <i
                  className="fa fa-spinner fa-spin"
                  style={{ padding: "10px" }}
                ></i>
              </div>
            ) : null}
          </div>
        </div>

        <SystemMaintenanceMessage />
        
      </div>
    </>
  );
}

export default connect(nsLoginSelect)(ApplyForMortgageLenderLicenceView);
